import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Globe, Instagram, Facebook, Linkedin, Youtube } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const socialLinks = [
  { icon: Instagram, href: 'https://www.instagram.com/dsotocleaningservice/', label: 'Instagram' },
  { icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61588268131598', label: 'Facebook' },
  { icon: Linkedin, href: 'https://www.linkedin.com/company/d-soto-cleaning/posts/?feedView=all', label: 'LinkedIn' },
  { icon: Youtube, href: 'https://www.youtube.com/@DSotoCleaningServices', label: 'YouTube' },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-logo-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/tp4zyo79_D%20Soto%20Cleaning%20Logo%20Color%202.png" 
            alt="D Soto Cleaning Logo" 
            className="footer-logo"
          />
        </div>
        <div className="footer-nav-menu">
          <Link to="/" className="footer-nav-link">{t('nav.home')}</Link>
          <Link to="/about" className="footer-nav-link">{t('nav.about')}</Link>
          <Link to="/services" className="footer-nav-link">{t('nav.services')}</Link>
          <Link to="/gallery" className="footer-nav-link">{t('nav.gallery')}</Link>
          <Link to="/blog" className="footer-nav-link">{t('nav.blog')}</Link>
          <Link to="/careers" className="footer-nav-link">{t('nav.careers')}</Link>
          <Link to="/contact" className="footer-nav-link">{t('nav.contact')}</Link>
        </div>
        <div className="footer-contact-row">
          <div className="footer-contact-item">
            <Phone size={18} />
            <a href="tel:4079461710">407-946-1710</a>
          </div>
          <div className="footer-contact-item">
            <Mail size={18} />
            <a href="mailto:Info@dsotocleaning.com">Info@dsotocleaning.com</a>
          </div>
          <div className="footer-contact-item">
            <Globe size={18} />
            <a href="https://dsotocleaning.com" target="_blank" rel="noopener noreferrer">dsotocleaning.com</a>
          </div>
        </div>
        <div className="footer-social" data-testid="footer-social">
          {socialLinks.map(({ icon: Icon, href, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label={label}
              data-testid={`social-${label.toLowerCase()}`}
            >
              <Icon size={20} />
            </a>
          ))}
        </div>
        <div className="footer-hours">
          {t('footer.hours')}
        </div>
        <div className="footer-bottom">
          <p className="footer-credit">{t('footer.credit')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
